module.exports = __webpack_public_path__ + "static/img/5.b68d8385.webp";